"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableState = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var __1 = require("../..");
var marker_drawable_1 = require("./marker.drawable");
var marker_offset_drawable_1 = require("./marker.offset.drawable");
var CollectionModelDrawableState = /** @class */ (function () {
    function CollectionModelDrawableState(collection, captureId) {
        this.drawables = mobx_1.observable.map();
        this.collection = collection;
        this.captureId = captureId;
    }
    CollectionModelDrawableState.prototype.clone = function () {
        var e_1, _a;
        var copy = new CollectionModelDrawableState(this.collection, this.captureId);
        try {
            for (var _b = tslib_1.__values(Array.from(this.drawables.values())), _c = _b.next(); !_c.done; _c = _b.next()) {
                var drawable = _c.value;
                drawable.clone(copy); // Cloning a drawable automatically inserts the new drawable into the new drawableState.
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return copy;
    };
    Object.defineProperty(CollectionModelDrawableState.prototype, "empty", {
        get: function () {
            return this.drawables.size === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableState.prototype, "base", {
        /**
         * Returns the base drawable
         */
        get: function () {
            var e_2, _a;
            try {
                for (var _b = tslib_1.__values(this.getAllDrawables()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var drawable = _c.value;
                    if (marker_drawable_1.CollectionModelDrawableMarker.isBase(drawable)) {
                        return drawable;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableState.prototype, "baseOffset", {
        get: function () {
            var e_3, _a;
            try {
                for (var _b = tslib_1.__values(this.getAllDrawables()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var drawable = _c.value;
                    if (marker_offset_drawable_1.CollectionModelDrawableMarkerOffset.isBaseOffset(drawable)) {
                        return drawable;
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableState.prototype, "insightMask", {
        get: function () {
            var _a;
            return (_a = this.getAllDrawables().find(function (d) { return d instanceof __1.CollectionModelDrawableMask; })) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableState.prototype.hasVisibleInsightMasks = function (enabledDetectionGroups, log) {
        var e_4, _a;
        try {
            for (var _b = tslib_1.__values(this.drawables.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var drawable = _c.value;
                if (!(drawable instanceof __1.CollectionModelDrawableMask)) {
                    continue;
                }
                if (drawable.getVisibleSvgDetectionGroups(enabledDetectionGroups, log)) {
                    return true;
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return false;
    };
    CollectionModelDrawableState.prototype.clear = function () {
        var e_5, _a;
        try {
            for (var _b = tslib_1.__values(this.getAllDrawables()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var drawable = _c.value;
                drawable.remove();
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
    };
    CollectionModelDrawableState.prototype.hasDrawable = function (drawableId) {
        return this.drawables.has(drawableId);
    };
    CollectionModelDrawableState.prototype.getDrawable = function (drawableId) {
        if (!this.drawables.has(drawableId)) {
            throw new Error("Cannot find drawable (id=".concat(drawableId, ") for capture ").concat(this.captureId));
        }
        var drawable = this.drawables.get(drawableId);
        if (!drawable) {
            throw new Error("Cannot find drawable (id=".concat(drawableId, ") for capture ").concat(this.captureId, " -- after \"has\" check succeeded!"));
        }
        return drawable;
    };
    CollectionModelDrawableState.prototype.getAllDrawables = function () {
        return Array.from(this.drawables.values());
    };
    CollectionModelDrawableState.prototype.values = function () {
        return this.getAllDrawables();
    };
    CollectionModelDrawableState.prototype.hasMeasurements = function () {
        return !this.empty;
    };
    CollectionModelDrawableState.prototype.hasUserMeasurements = function () {
        return this.getAllDrawables().some(function (drawable) { return drawable.isUserMeasurement; });
    };
    CollectionModelDrawableState.prototype.hasOnlyInsightDetections = function () {
        var drawables = this.getAllDrawables();
        return drawables.length > 0 && drawables.every(function (drawable) { return drawable.isInsightMeasurement; });
    };
    CollectionModelDrawableState.prototype.hasInsightDetections = function () {
        return this.getAllDrawables().some(function (drawable) { return drawable.isInsightMeasurement; });
    };
    CollectionModelDrawableState.prototype.hasAppliedInsightDetections = function () {
        return this.getAllDrawables().some(function (drawable) {
            var _a;
            return drawable instanceof marker_drawable_1.CollectionModelDrawableMarker
                && ((_a = drawable.insight) === null || _a === void 0 ? void 0 : _a.applied);
        });
    };
    CollectionModelDrawableState.prototype.clearInsightDetections = function () {
        var e_6, _a;
        try {
            for (var _b = tslib_1.__values(this.getAllDrawables()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var drawable = _c.value;
                if (drawable.isInsightMeasurement) {
                    drawable.remove();
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_6) throw e_6.error; }
        }
    };
    Object.defineProperty(CollectionModelDrawableState.prototype, "capture", {
        /**
         * @deprecated Use {@link getCaptureAsync()} instead.
         */
        get: function () {
            return this.collection.state.getCapture(this.captureId);
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableState.prototype.getCaptureAsync = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.collection.state.loader.Capture.getById(this.captureId).fetch()];
            });
        });
    };
    CollectionModelDrawableState.prototype.equals = function (other) {
        var e_7, _a;
        // This function is written to perform every comparison every time so that
        // mobx can track the dependencies of the equality process.
        var equal = true;
        if (this.captureId !== other.captureId) {
            equal = false;
        }
        var keys = Array.from(this.drawables.keys());
        var otherKeys = Array.from(other.drawables.keys());
        if (keys.length !== otherKeys.length) {
            equal = false;
        }
        if (keys.some(function (key) { return !otherKeys.includes(key); })) {
            equal = false;
        }
        if (otherKeys.some(function (key) { return !keys.includes(key); })) {
            equal = false;
        }
        try {
            for (var _b = tslib_1.__values(Array.from(this.drawables.entries())), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = tslib_1.__read(_c.value, 2), drawableId = _d[0], drawable = _d[1];
                var otherDrawable = other.drawables.get(drawableId);
                if (!otherDrawable) {
                    equal = false;
                }
                else if (!drawable.equals(otherDrawable)) {
                    equal = false;
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_7) throw e_7.error; }
        }
        return equal;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionModelDrawableState.prototype, "drawables", void 0);
    return CollectionModelDrawableState;
}());
exports.CollectionModelDrawableState = CollectionModelDrawableState;
//# sourceMappingURL=drawable.state.js.map